<template>
  <section :class="rootClassnames"
    v-if="sortedVariants && sortedVariants.length > 0 && tabActiveId === 'overview'"
  >
    <header :class="`${ns}__header`">
      <h2 :class="`${ns}__title`">Variants</h2>
    </header>

    <div :class="`${ns}__table-container`">

      <div :class="`${ns}__table`" v-if="variantsViewStyle === 'full'">
        <div :class="`${ns}__thead`">
          <div :class="`${ns}__tr`">
            <div :class="`${ns}__th`">Image</div>
            <div :class="`${ns}__th`">Title</div>
            <div :class="`${ns}__th`">SKU</div>
            <div :class="`${ns}__th`">Current Availability</div>
            <div :class="`${ns}__th`">Units Sold</div>
            <div :class="`${ns}__th`">Gross Sales</div>
            <div :class="`${ns}__th`">Discounts</div>
            <div :class="`${ns}__th`">Returns</div>
            <div :class="`${ns}__th`">Net Sales</div>
          </div>
        </div>
        <div :class="`${ns}__tbody`">
          <div
            :class="`${ns}__tr`"
            v-for="(variant, key) in sortedVariants"
            :key="key"
          >
            <div :class="`${ns}__td`">
              <div :class="`${ns}__image`">
                <div
                  :class="`${ns}__image-actual`"
                  v-if="variant.image"
                  :style="{ backgroundImage: `url(${ variant.image })` }"
                />
              </div>
            </div>
            <div :class="`${ns}__td`">{{ variant.title }}</div>
            <div :class="`${ns}__td`">{{ variant.sku }}</div>
            <div :class="`${ns}__td`">{{ variant.inventory }}</div>
            <div :class="`${ns}__td`">{{ variant.quantity }}</div>
            <div :class="`${ns}__td`">{{ variant.price | currency }}</div>
            <div :class="`${ns}__td`">{{ variant.total_discount | currency }}</div>
            <div :class="`${ns}__td`">{{ variant.refund | currency }}</div>
            <div :class="`${ns}__td`">{{ variant.net_price | currency }}</div>
          </div>
        </div>
      </div>

      <div :class="`${ns}__table`" v-if="variantsViewStyle === 'tab-inventory'">
        <div :class="`${ns}__thead`">
          <div :class="`${ns}__tr`">
            <div :class="`${ns}__th`">Image</div>
            <div :class="`${ns}__th`">Title</div>
            <div :class="`${ns}__th`">SKU</div>
            <div :class="`${ns}__th`">Availability</div>
          </div>
        </div>
        <div :class="`${ns}__tbody`">
          <div
            :class="`${ns}__tr`"
            v-for="(variant, key) in sortedVariants"
            :key="key"
          >
            <div :class="`${ns}__td`">
              <div :class="`${ns}__image`">
                <div
                  :class="`${ns}__image-actual`"
                  v-if="variant.image"
                  :style="{ backgroundImage: `url(${ variant.image })` }"
                />
              </div>
            </div>
            <div :class="`${ns}__td`">{{ variant.title }}</div>
            <div :class="`${ns}__td`">{{ variant.sku }}</div>
            <div :class="`${ns}__td`">{{ variant.inventory }}</div>
          </div>
        </div>
      </div>

      <div :class="`${ns}__table`" v-if="variantsViewStyle === 'tab-best'">
        <div :class="`${ns}__thead`">
          <div :class="`${ns}__tr`">
            <div :class="`${ns}__th`">Image</div>
            <div :class="`${ns}__th`">Title</div>
            <div :class="`${ns}__th`">SKU</div>
            <div :class="`${ns}__th`">Units Sold</div>
            <div :class="`${ns}__th`">Net Sales</div>
          </div>
        </div>
        <div :class="`${ns}__tbody`">
          <div
            :class="`${ns}__tr`"
            v-for="(variant, key) in sortedVariants.slice(0,1)"
            :key="key"
          >
            <div :class="`${ns}__td`">
              <div :class="`${ns}__image`">
                <div
                  :class="`${ns}__image-actual`"
                  v-if="variant.image"
                  :style="{ backgroundImage: `url(${ variant.image })` }"
                />
              </div>
            </div>
            <div :class="`${ns}__td`">{{ variant.title }}</div>
            <div :class="`${ns}__td`">{{ variant.sku }}</div>
            <div :class="`${ns}__td`">{{ variant.quantity }}</div>
            <div :class="`${ns}__td`">{{ variant.net_price | currency }}</div>
          </div>
        </div>
      </div>

      <div :class="`${ns}__table`" v-if="variantsViewStyle === 'tab-worst'">
        <div :class="`${ns}__thead`">
          <div :class="`${ns}__tr`">
            <div :class="`${ns}__th`">Image</div>
            <div :class="`${ns}__th`">Title</div>
            <div :class="`${ns}__th`">SKU</div>
            <div :class="`${ns}__th`">Units Sold</div>
            <div :class="`${ns}__th`">Net Sales</div>
          </div>
        </div>
        <div :class="`${ns}__tbody`">
          <div
            :class="`${ns}__tr`"
            v-for="(variant, key) in sortedVariants.slice(-1)"
            :key="key"
          >
            <div :class="`${ns}__td`">
              <div :class="`${ns}__image`">
                <div
                  :class="`${ns}__image-actual`"
                  v-if="variant.image"
                  :style="{ backgroundImage: `url(${ variant.image })` }"
                />
              </div>
            </div>
            <div :class="`${ns}__td`">{{ variant.title }}</div>
            <div :class="`${ns}__td`">{{ variant.sku }}</div>
            <div :class="`${ns}__td`">{{ variant.quantity }}</div>
            <div :class="`${ns}__td`">{{ variant.net_price | currency }}</div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
  import _filter from 'lodash/filter'
  import _find from 'lodash/find'
  import _includes from 'lodash/includes'
  import _orderBy from 'lodash/orderBy'

  export default {
    name: 'ProductDetailVariants',
    computed: {
      sortedVariants: function () {
        return _orderBy(this.productVariants, ['net_price'], ['desc'])
      },
      rootClassnames: function () {
        const {
          ns
        } = this

        const classnames = `${ns}`

        return classnames
      }
    },
    props: {
      tab: false,
      sales: Object,
      propsProduct: Object,
      propsProductVariants: Array,
      productId: {
        default: '',
        required: true,
        type: String
      },
      tabActiveId: {
        default: '',
        required: true,
        type: String
      },
      variantsViewStyle: {
        default: 'full',
        type: String
      }
    },
    data () {
      return {
        ns: 'product-detail-variants',
        product: this.propsProduct ? this.propsProduct : null,
        productVariants: this.propsProductVariants ? this.propsProductVariants : null
      }
    },
    methods: {
      clearProductVariants () {
        this.productVariants = null
      },
      loadProductVariants (variants) {
        this.productVariants = variants
      },
      setProductVariants () {
        let sales = this.$parent.sales

        if (sales) {
          if (this.product) {
            let variantIds = this.$parent.variantIds
            var variants = this.product.variants

            if (variantIds && variantIds.length > 0) {
              variants = _filter(variants, item => _includes(variantIds, item.id))
            }

            for (let item of variants) {
              let productItem = _find(sales.item_sales, ['variant_id', item.id])

              if (typeof productItem !== 'undefined') {
                item.quantity = productItem.quantity
                item.price = productItem.price
                item.total_discount = productItem.total_discount
                item.refund = productItem.refund
                item.net_price = productItem.net_price
                item.total_tax = productItem.total_tax
                item.total_price = productItem.total_price
              } else {
                item.quantity = 0
                item.price = 0
                item.total_discount = 0
                item.refund = 0
                item.net_price = 0
                item.total_tax = 0
                item.total_price = 0
              }

              if (this.product.images && this.product.images.length > 0 && item.image_id) {
                const image = _find(this.product.images, ['id', item.image_id])

                item.image = image.url
              } else if (this.product.images && this.product.images.length > 0) {
                item.image = this.product.images[0].url
              }
            }

            this.loadProductVariants(variants)
          }
        } else {
          this.clearProductVariants()
        }
      }
    },
    watch: {
      productId: function () {
        this.clearProductVariants()
      },
      '$parent.product': function (arr) {
        this.product = arr
      },
      '$parent.sales': function () {
        this.setProductVariants()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ProductDetailVariants.vue